var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-card"},[_c('asset-v3',{staticClass:"exclamationIcon",attrs:{"dir":_vm.dir,"name":_vm.icon}}),_c('h1',[_vm._v(" Ops! Houve um erro ao carregar o conteúdo da página ")]),_c('p',{staticClass:"lead"},[_vm._v(" Por favor, tente acessar novamente mais tarde. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }